import React from 'react';
import Layouts from 'layouts';
import OgImage from 'images/promotions/banner-alltopasia-promotion-cover--6.5%-per-week.jpg';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-intl';
import ComponentTemplate from '../../promotion-template/component-template';

const PromotionsPage = (props) => {
  const intl = useIntl();
  const { location } = props;

  return (
    <Layouts
      title={intl.formatMessage({ id: 'page.home.title' })}
      description={intl.formatMessage({ id: 'page.home.description' })}
      image={OgImage}
      pathname={location.pathname}
    >
      <ComponentTemplate
        cover="/casino-daily-bonus-20-unlimited.jpg"
        title="Sport Daily Bonus 20% Unlimited!!"
        subTitle="รับโบนัส สูงสุด 500 บาท"
        desc="ทำยอดชนะ 10 เท่า สามารถถอนได้สูงสุด 100 เท่าของยอดฝาก"
        howto="ยอดฝาก = 100 บาท ยอดโบนัส = 20 บาท ยอดชนะที่ต้องการ = (100 + 20 ) x 10 = 1,200 บาท (ไม่รวมทุน)"
        note="สมาชิกสามารถรับโปรโมชั่นนี้ได้วันละ 1 ครั้ง เท่านั้น สมาชิกต้องเดิมพันขั้นต่ำ 20 บาท จำนวน 10 บิลขึ้นไป ถึงจะผ่านเงื่อนไข โปรโมชั่นนี้สำหรับการเดิมพันประเภท Sport เท่านั้น หากสมาชิกมีการเดิมพันประเภท Slot,Casino ทาง alltopasia จะทำการคืนทุนทุกกรณี สมาชิกที่อยู่ Gen Bronze ขึ้นไปถึงสามารถรับโปรโมชั่นนี้ได้"
      />
    </Layouts>
  );
};

PromotionsPage.propTypes = {
  location: PropTypes.string.isRequired,
};

export default PromotionsPage;
